(function(){
  if(window.__ncHelpers)return;window.__ncHelpers=1;
  var J={'Content-Type':'application/json'};
  var CODE='SUSCRIPCION15',OLD='SUSCRIPCION10',KEY='Suscripción';
  window.__ncProps=async function(key){
    try{var c=await (await fetch('/cart.js')).json();
      var it=(c.items||[]).filter(function(i){return i.key===key})[0];
      if(!it||!it.properties)return null;
      var o={},n=0;for(var k in it.properties){var v=it.properties[k];if(v!=null&&v!==''){o[k]=v;n++}}
      return n?o:null}catch(e){return null}
  };
  window.__ncSync=async function(){
    try{
      var c=await (await fetch('/cart.js')).json();
      var hasSub=(c.items||[]).some(function(i){return i.properties&&i.properties[KEY]});
      var codes=(c.discount_codes||[]).map(function(d){return String(d.code||'')});
      var up=function(x){return x.toUpperCase()};
      var hasCode=codes.some(function(x){return up(x)===CODE});
      var hasOld=codes.some(function(x){return up(x)===OLD});
      var others=codes.filter(function(x){return up(x)!==CODE&&up(x)!==OLD});
      if(hasSub&&!hasCode&&others.length===0){await fetch('/cart/update.js',{method:'POST',headers:J,body:JSON.stringify({discount:CODE})});return true}
      if((!hasSub&&(hasCode||hasOld))||(hasSub&&hasOld)){await fetch('/cart/update.js',{method:'POST',headers:J,body:JSON.stringify({discount:(hasSub&&others.length===0)?CODE:others.join(',')})});return true}
    }catch(e){}
    return false;
  };
})();
(function(){if(window.__ncUp)return;window.__ncUp=1;
  async function refresh(){
    try{var r=await fetch(location.pathname+'?section_id=cart-drawer-section');var html=await r.text();
    var doc=new DOMParser().parseFromString(html,'text/html');
    var nw=doc.querySelector('.cart-drawer__inner .cart-items-component'),old=document.querySelector('#cart-drawer .cart-drawer__inner .cart-items-component');
    if(nw&&old){old.replaceWith(nw)}else{location.reload()}}catch(e){location.reload()}
  }
  var J={'Content-Type':'application/json'};
  document.addEventListener('click',async function(e){
    var b=e.target.closest&&e.target.closest('.nc-up__btn,.nc-up__btn--swap');
    if(b){e.preventDefault();b.disabled=true;
      try{var pr=await window.__ncProps(b.dataset.ncKey);var it={id:+b.dataset.ncNext,quantity:1};if(pr)it.properties=pr;
      await fetch('/cart/add.js',{method:'POST',headers:J,body:JSON.stringify({items:[it]})});
      await fetch('/cart/change.js',{method:'POST',headers:J,body:JSON.stringify({id:b.dataset.ncKey,quantity:0})});}catch(err){}
      await refresh();if(window.__ncSyncRun)window.__ncSyncRun();return;}
    var a=e.target.closest&&e.target.closest('[data-nc-apply]');
    if(a){e.preventDefault();var box=a.closest('.nc-cp'),inp=box.querySelector('[data-nc-code]'),err=box.querySelector('[data-nc-err]');var code=(inp.value||'').trim();if(!code)return;a.disabled=true;
      try{var r=await fetch('/cart/update.js',{method:'POST',headers:J,body:JSON.stringify({discount:code})});var c=await r.json();
      var ok=(c.discount_codes||[]).some(function(d){return d.code.toLowerCase()===code.toLowerCase()&&d.applicable});
      if(ok){return refresh()}err.hidden=false;a.disabled=false}catch(x){err.hidden=false;a.disabled=false}
      return;}
    var cl=e.target.closest&&e.target.closest('[data-nc-close]');
    if(cl){var d=document.getElementById('cart-drawer');if(d&&d.close)d.close();else{var dg=document.querySelector('#cart-drawer dialog');dg&&dg.close()}}
  });
})();
(function(){if(window.__ncQty)return;window.__ncQty=1;
  var J={'Content-Type':'application/json'};
  var busy=false;
  function vmap(){try{return JSON.parse((document.getElementById('nc-vmap')||{}).textContent||'{}')}catch(e){return {}}}
  function vinfo(row){
    var qs=row.querySelector('.quantity-selector');var vid=qs&&qs.dataset.variantId;
    var list=vid&&vmap()[vid];if(!list||list.length<2)return null;
    var cur=null;list.forEach(function(v){if(String(v.id)===String(vid))cur=v});if(!cur)return null;
    return {cur:cur,list:list};
  }
  function lineQty(row){var inp=row.querySelector('.quantity-selector input');return parseInt(inp&&inp.getAttribute('value'),10)||1}
  function decorate(){
    document.querySelectorAll('#cart-drawer .cart-items__table-row').forEach(function(row){
      var info=vinfo(row);var inp=row.querySelector('.quantity-selector input');if(!inp)return;
      inp.removeAttribute('disabled');
      row.querySelectorAll('.quantity-selector button').forEach(function(b){b.removeAttribute('disabled')});
      if(!info)return;
      var s=lineQty(row)*info.cur.s;
      row.classList.add('nc-bundle');row.dataset.ncSets=s;
      if(document.activeElement!==inp)inp.value=s;
    });
  }
  function restoreReal(){
    document.querySelectorAll('#cart-drawer .quantity-selector input').forEach(function(inp){
      var v=inp.getAttribute('value');if(v!=null&&v!=='')inp.value=v;
    });
  }
  document.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('#cart-drawer [name="checkout"],#cart-drawer .cart__checkout-button'))restoreReal()},true);
  document.addEventListener('submit',function(e){var f=e.target;if(f&&(f.id==='cart-form'||(f.closest&&f.closest('#cart-drawer'))))restoreReal()},true);
  window.addEventListener('pageshow',function(){setTimeout(decorate,50)});
  function pack(list,total){
    var av=list.filter(function(v){return v.a}).sort(function(a,b){return b.s-a.s});
    var items=[],rem=total;
    av.forEach(function(v){var c=Math.floor(rem/v.s);if(c>0){items.push({id:v.id,quantity:c});rem-=c*v.s}});
    return items;
  }
  async function refresh(){
    var r=await fetch(location.pathname+'?section_id=cart-drawer-section');var html=await r.text();
    var doc=new DOMParser().parseFromString(html,'text/html');
    var oi=document.querySelector('#cart-drawer .cart-drawer__inner'),ni=doc.querySelector('.cart-drawer__inner');
    if(oi&&ni){oi.replaceWith(ni);decorate()}else{location.reload()}
  }
  async function apply(row,q,delta){
    if(busy||!row)return;var key=row.dataset.key;if(!key)return;
    var info=vinfo(row),cart;
    busy=true;row.classList.add('nc-busy');
    try{
      if(info){
        var curSets=parseInt(row.dataset.ncSets,10)||lineQty(row)*info.cur.s;
        var total=delta!=null?curSets+delta:q;if(total<0)total=0;
        if(total===curSets){row.classList.remove('nc-busy');busy=false;return}
        var inp=row.querySelector('.quantity-selector input');if(inp)inp.value=total;
        var props=await window.__ncProps(key);
        await fetch('/cart/change.js',{method:'POST',headers:J,body:JSON.stringify({id:key,quantity:0})});
        var items=total>0?pack(info.list,total):[];
        if(props)items.forEach(function(x){x.properties=props});
        if(items.length){await fetch('/cart/add.js',{method:'POST',headers:J,body:JSON.stringify({items:items})})}
        cart=await (await fetch('/cart.js')).json();
      }else{
        var nq=delta!=null?Math.max(0,lineQty(row)+delta):q;
        var inp2=row.querySelector('.quantity-selector input');if(inp2)inp2.value=nq;
        cart=await (await fetch('/cart/change.js',{method:'POST',headers:J,body:JSON.stringify({id:key,quantity:nq})})).json();
      }
      await refresh();
      document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'nc-qty',data:{source:'nc-qty',itemCount:cart.item_count}}}));
    }catch(err){location.reload()}
    finally{busy=false}
  }
  function stop(e){e.preventDefault();e.stopPropagation();e.stopImmediatePropagation()}
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('#cart-drawer .quantity-selector .quantity-plus,#cart-drawer .quantity-selector .quantity-minus,#cart-drawer .cart-items__remove');
    if(!b)return;stop(e);
    var row=b.closest('.cart-items__table-row');if(!row)return;
    if(b.classList.contains('cart-items__remove'))return apply(row,0,null);
    apply(row,null,b.classList.contains('quantity-plus')?1:-1);
  },true);
  function onInput(e){
    var inp=e.target;if(!inp.matches||!inp.matches('#cart-drawer .quantity-selector input'))return;
    e.stopImmediatePropagation();
    var row=inp.closest('.cart-items__table-row');var q=Math.max(0,parseInt(inp.value,10)||0);
    var cur=row.classList.contains('nc-bundle')?parseInt(row.dataset.ncSets,10):lineQty(row);
    if(q===cur)return;
    apply(row,q,null);
  }
  document.addEventListener('blur',onInput,true);
  document.addEventListener('change',onInput,true);
  document.addEventListener('keydown',function(e){if(e.key==='Enter'&&e.target.matches&&e.target.matches('#cart-drawer .quantity-selector input')){e.preventDefault();e.target.blur()}},true);
  decorate();
  var host=document.getElementById('cart-drawer');
  if(host){var obs=new MutationObserver(function(){decorate()});obs.observe(host,{childList:true,subtree:true})}
  document.addEventListener('cart:update',function(){setTimeout(decorate,50)});
  var syncing=false;
  async function runSync(){if(syncing)return;syncing=true;try{if(await window.__ncSync()&&document.querySelector('#cart-drawer .cart-drawer__inner'))await refresh()}catch(e){}finally{syncing=false}}
  window.__ncSyncRun=runSync;
  document.addEventListener('cart:update',function(){setTimeout(runSync,400)});
  runSync();
})();
document.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('#cart-drawer .theme-drawer__close-button');if(!b)return;e.preventDefault();var d=document.getElementById('cart-drawer');if(d&&typeof d.close==='function'){d.close()}else{var g=document.querySelector('#cart-drawer dialog');g&&g.close()}},true);
